export default "__VITE_ASSET__0884cc75__"